export default function trieDate(echeancierPaiement) {
  echeancierPaiement.sort((premiereEcheance, secondeEcheance) => {
    return new Date(premiereEcheance.dateEcheance) - new Date(secondeEcheance.dateEcheance);
  });
}
